import React, { useState, useContext } from 'react';
import { IconButton, Menu, MenuItem, Tooltip, Typography } from '@mui/material';
import GTranslateIcon from '@mui/icons-material/GTranslate';
import { LanguageContext } from '../../controller/context/languageContext';
 // Import the context

const languages = [
  { code: 'en', label: 'English' },
  { code: 'es', label: 'Español' },
  { code: 'fr', label: 'Français' },
  { code: 'de', label: 'Deutsch' },
  { code: 'ko', label: 'Korean' },
  // Add more languages as needed
];

const LanguageSelector = () => {
  const { language, setLanguage } = useContext(LanguageContext); // Access context here
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleSelectLanguage = (langCode) => {
    setLanguage(langCode);  // Update the context with the selected language
    handleClose();
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Tooltip  title={<Typography variant='caption'>Select Language (Beta)</Typography>}>
        <IconButton
          color="inherit"
          onClick={handleClick}
          aria-controls="language-menu"
          aria-haspopup="true"
        >
          <GTranslateIcon htmlColor='dodgerBlue'/>
        </IconButton>
      </Tooltip>
      <Menu
        id="language-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {languages.map((lang) => (
          <MenuItem
            key={lang.code}
            selected={lang.code === language}
            onClick={() => handleSelectLanguage(lang.code)}
          >
            {lang.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LanguageSelector;
